import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { SportEventOfferFragmentDoc } from './SportEventOffersV2.fragment';
export type SportEventBundle_MultiStepSportEvent_Fragment = {
	__typename?: 'MultiStepSportEvent';
	bundles: Array<{
		__typename?: 'PromotedSportBundleEdge';
		sportPromotionUrl: string;
		node: {
			__typename?: 'Bundle';
			id: string;
			clearName: string;
			technicalName: string;
			bundleId: number;
			packages: Array<{ __typename?: 'Package'; id: string; icon: string; clearName: string; packageId: number }>;
		};
		offer: {
			__typename?: 'SportOffer';
			monetizationType: Types.MonetizationType;
			presentationType: Types.PresentationType;
			audioLanguage?: string | null;
			standardWebURL?: string | null;
			sportObjectType: Types.SportObjectType;
			package: {
				__typename?: 'Package';
				id: string;
				packageId: number;
				technicalName: string;
				clearName: string;
				shortName: string;
				monetizationTypes: Array<Types.MonetizationType>;
			};
		};
	}>;
};

export type SportEventBundle_SingleStepSportEvent_Fragment = {
	__typename?: 'SingleStepSportEvent';
	bundles: Array<{
		__typename?: 'PromotedSportBundleEdge';
		sportPromotionUrl: string;
		node: {
			__typename?: 'Bundle';
			id: string;
			clearName: string;
			technicalName: string;
			bundleId: number;
			packages: Array<{ __typename?: 'Package'; id: string; icon: string; clearName: string; packageId: number }>;
		};
		offer: {
			__typename?: 'SportOffer';
			monetizationType: Types.MonetizationType;
			presentationType: Types.PresentationType;
			audioLanguage?: string | null;
			standardWebURL?: string | null;
			sportObjectType: Types.SportObjectType;
			package: {
				__typename?: 'Package';
				id: string;
				packageId: number;
				technicalName: string;
				clearName: string;
				shortName: string;
				monetizationTypes: Array<Types.MonetizationType>;
			};
		};
	}>;
};

export type SportEventBundleFragment =
	| SportEventBundle_MultiStepSportEvent_Fragment
	| SportEventBundle_SingleStepSportEvent_Fragment;

export const SportEventBundleFragmentDoc = gql`
	fragment SportEventBundle on SportEventV2 {
		bundles(country: $country, platform: $platform, filter: { bestOnly: false }) {
			node {
				id
				clearName
				technicalName
				bundleId
				packages(country: $country, platform: $platform) {
					id
					icon
					clearName
					packageId
				}
			}
			sportPromotionUrl
			offer {
				...SportEventOffer
			}
		}
	}
	${SportEventOfferFragmentDoc}
`;
